//
//
//
//
//
//
//
//

    import tHeader from 'components/tHeader'
    import tFooter from 'components/tFooter'
    export default {
        props: ['layoutData'],
        name: "t-layout",
        data() {
            return {}
        },
        components: {
            tHeader,
            tFooter
        }
    }



// WEBPACK FOOTER //
// ./src/components/tLayout.vue